import React from 'react';
import { Avatar, Tooltip, makeStyles } from '@material-ui/core';

const ACC_TYPE_MAP = {
  1: {
    cd: 'A',
    dsc: 'Asset'
  },
  2: {
    cd: 'L',
    dsc: 'Liabilities'
  },
  3: {
    cd: 'E',
    dsc: 'Equity'
  },

  4: {
    cd: 'R',
    dsc: 'Revenue'
  },
  5: {
    cd: 'E',
    dsc: 'Expenses'
  },
  6: {
    cd: 'OI',
    dsc: 'Other Income'
  },
  7: {
    cd: 'OE',
    dsc: 'Other Expenses'
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '1.5em',
    width: '1.5em',
    fontSize: 'inherit',
    background: theme.palette.primary.main
  }
}));

function AccountTypeAvatar({ type }) {
  const classes = useStyles();
  return (
    <Tooltip title={ACC_TYPE_MAP?.[type]?.dsc ?? ''}>
      <Avatar className={classes.root} variant="square">
        {ACC_TYPE_MAP?.[type]?.cd ?? ''}
      </Avatar>
    </Tooltip>
  );
}

export default AccountTypeAvatar;
